import { render, staticRenderFns } from "./DialogKyukaShinsei.vue?vue&type=template&id=052e9d52&scoped=true"
import script from "./DialogKyukaShinsei.vue?vue&type=script&lang=js"
export * from "./DialogKyukaShinsei.vue?vue&type=script&lang=js"
import style0 from "./DialogKyukaShinsei.vue?vue&type=style&index=0&id=052e9d52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052e9d52",
  null
  
)

export default component.exports